<template>
  <b-form-group
    label="Kullanıcı"
    label-for="value"
  >
    <validation-provider
      #default="{ errors }"
      name="Kullanıcı"
      rules="required"
    >
      <v-select
        v-model="dataItem.value"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Giriniz"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'PurchaseOfferConfigUserSelect',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['users/dataList']
    },
    dataItem() {
      return this.$store.getters['purchaseOfferConfig/dataItem']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('users/getDataList', {
        select: [
          'users.id AS id',
          'users.name AS title',
        ],
        where: {
          'users.status': 1,
        },
      })
    },
  },
}
</script>
